import {showSuccessNotification} from '../global/notifications';

export default function () {
    let $pid = $('#Project_Pid'), $projectTitle = $('#ProjectTitle');

    if ($pid.length && $projectTitle.length) {
        showSuccessNotification(`Successfully Loaded\n ${$projectTitle.val()}`);
    } else {
        setupProjectSelection();
    }
}

const setupProjectSelection = () => {
    let $closedJobs = $('#closedJobs');

    if ($closedJobs.length) {
        $closedJobs.change(function () {
            let responseValue = $closedJobs.prop('checked').toString();
            $('[name=closedJobs]')[1].value = responseValue;
            $closedJobs.val(responseValue);
            $('#projectTitle').data('kendoAutoComplete').dataSource.read();
        });
        let k_projectTitle = $('#projectTitle').data('kendoAutoComplete');
        if (k_projectTitle) {
            k_projectTitle.dataSource.transport.options.read.data = function () {
                return {
                    includeClosed: $closedJobs.prop('checked').toString()
                };
            };
        }
    }
};